import { hasTradePlatformAccess } from './authAccess';
import { canAccessTradeWorkspace } from './brokerConnection';

/** Trade page deep-link with ticker pre-selected (stripped after chart applies it). */
export function tradePathWithSymbol(symbol) {
  const sym = String(symbol || '').trim().toUpperCase();
  if (!sym) return '/trade';
  return `/trade?symbol=${encodeURIComponent(sym)}`;
}

export function isDashboardPath(pathname) {
  return Boolean(pathname?.startsWith('/dashboard'));
}

/**
 * True when symbol clicks may open Trade / set the chart ticker.
 * Requires platform access and an effective MD source (selected or sibling).
 */
export function canOpenTradeWithSymbol(user, account = null) {
  if (!hasTradePlatformAccess(user)) return false;
  return canAccessTradeWorkspace(user, account) !== false;
}

/**
 * Open the trade workspace with symbol selected. Order entry remains Pro-only.
 * Passes location.state.page=trade so mobile Trade shell opens the chart tab
 * (not Analytics/Health restored from localStorage).
 * @returns {boolean} true when navigation was performed
 */
export function navigateToTradeWithSymbol(navigate, symbol, user, account = null, options = {}) {
  if (!canOpenTradeWithSymbol(user, account)) return false;
  const sym = String(symbol || '').trim();
  if (!sym) return false;
  const backTo = typeof options.backTo === 'string' && options.backTo.trim()
    ? options.backTo
    : undefined;
  const backTitle = typeof options.backTitle === 'string' && options.backTitle.trim()
    ? options.backTitle
    : undefined;
  navigate(tradePathWithSymbol(sym), {
    state: {
      page: 'trade',
      ...(backTo ? { backTo } : {}),
      ...(backTitle ? { backTitle } : {}),
    },
  });
  return true;
}

export function getTradeNestedBackTo(locationState) {
  const backTo = locationState?.backTo;
  return typeof backTo === 'string' && backTo.trim() ? backTo : null;
}
